import React from 'react';
import {
  PrimaryAlertDetailsView,
  AlertDetailsErrorView,
  AlertDetailsLoadingView,
} from './components/PrimaryAlertDetailsView';

const AlertDetails = ({
  datatestid,
  selectedAlert,
  defaultAlertId,
  alertDetailsLoading,
  alertDetailsError,
  alertDetailsConfig,
  selectedAlertId,
  detailsLinkClick,
  isMobileView,
  experimentMeta,
  showNewTemplate,
  iFrameConfig,
  listLinkCallback,
}) => {
  if (alertDetailsLoading || (!alertDetailsConfig && !alertDetailsError)) {
    return <AlertDetailsLoadingView />;
  }

  if (alertDetailsError) {
    return (
      <div data-testid={datatestid ? `${datatestid}-cmAlertsList` : null}>
        <AlertDetailsErrorView />
      </div>
    );
  }
  return (
    <div
      className="cmAlertsDetailsContainer notificationsAlertsDetails"
      data-testid={datatestid ? `${datatestid}-alertsList` : null}
    >
      {alertDetailsConfig && (
        <PrimaryAlertDetailsView
          alertDetailsConfig={alertDetailsConfig}
          datatestid={`${selectedAlert}-alertDetails`}
          selectedAlertId={selectedAlertId}
          defaultAlertId={defaultAlertId}
          alertDetailsLoading={alertDetailsLoading}
          detailsLinkClick={detailsLinkClick}
          isMobileView={isMobileView}
          experimentMeta={experimentMeta}
          showNewTemplate={showNewTemplate}
          iFrameConfig={iFrameConfig}
          listLinkCallback={listLinkCallback}
        />
      )}
    </div>
  );
};

export { AlertDetails };
